import {ChatCompletionSystemMessageParam} from 'openai/resources';
import {OpenAIRole} from '../openAI.enums';

function openAISystemMessage(content: string): ChatCompletionSystemMessageParam {
  return {
    role: OpenAIRole.System,
    content,
  };
}

export default openAISystemMessage;
